import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { CanvasKeyFrames } from '@/utils/canvaskeyframes';
import { createEFPic } from '@/utils/useEFPic';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

const { EFFigure } = createEFPic('/media/x-stream/pc/');

export default function B() {
    const { useEffect, useLang, useRef, useState } = useGlobal();
    const { t } = useLang('xstream');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    // 序列帧-1 section-2
    const imgCount = 47;
    let canvasFrames1: any;
    const loadImage1 = (imageCount: number) => {
        const imageEleArr: any[] = [];
        return new Promise((resolve, reject) => {
            let loadImageCount = 0;
            for (let i = 0; i < imageCount; i++) {
                const imageEle = new window.Image();
                imageEleArr.push(imageEle);
                imageEle.onload = function () {
                    loadImageCount++;
                    if (loadImageCount >= imageCount) {
                        // 此时图片全部加载完成
                        resolve(imageEleArr);
                    }
                };
                imageEle.onerror = reject;
                const strIndex = `00${i}`.slice(-2);
                imageEle.src = handleDynamicPath(`/media/x-stream/pc/animation/section02/x-stream_p2_web_000${strIndex}.jpg`);
            }
        });
    };

    useEffect(() => {
        // 提前 loadImage
        const container = document.querySelector('#canvas-frames1');
        if (!container) return;
        loadImage1(imgCount).then((imgArr) => {
            canvasFrames1 = new CanvasKeyFrames(container, 'array', imgArr, {
                width: '100%',
                height: '100%',
                fps: 30,
            });
        });
    }, []);

    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        // 滚动scroll播放
        const scene1 = new ScrollMagic.Scene({
            triggerElement: '.xstream_B',
            triggerHook: 1,
            duration: layoutH + 400,
        });
        scene1.on('progress', (_self: any) => {
            const currentFrame = Math.floor(_self?.progress * (imgCount - 1));
            canvasFrames1?.goto(currentFrame);
        });
        scene1.addTo(controller);
    }, []);

    // sec2 - 文字+蒙层渐变出现
    useEffect(() => {
        new ScrollMagic.Scene({
            triggerElement: '.xstream_B .section-2 .title',
            triggerHook: 1,
            offset: 200,
            duration: 200,
        })
            .setTween(TweenMax.to('.xstream_B .section-2 .title', 0.5, { opacity: 1 }))
            .addTo(controller);

        new ScrollMagic.Scene({
            triggerElement: '.xstream_B .section-2 .desc',
            triggerHook: 1,
            offset: 150,
            duration: 200,
        })
            .setTween(TweenMax.to('.xstream_B .section-2 .desc', 0.5, { opacity: 1 }))
            .addTo(controller);
    }, []);

    //sec3 图片列表触发动画
    const [enter, setEnter] = useState(false);
    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        new ScrollMagic.Scene({
            triggerElement: '.xstream_B',
            triggerHook: 1,
            offset: layoutH + 300,
        })
            .on('enter', () => {
                setEnter(true);
            })
            .on('leave', () => {
                setEnter(false);
            })
            .addTo(controller);
    }, []);

    let timer0: any = null;
    let timer1: any = null;
    let timer2: any = null;
    const [xstreamNum, setXstreamNum] = useState(0);
    const [otherNum, setOtherNum] = useState(0);
    const xstreamNumRef = useRef(null);
    const otherNumRef = useRef(null);
    xstreamNumRef.current = () => {
        if (xstreamNum >= 80) {
            clearTimeout(timer0);
            clearInterval(timer1);
        } else {
            setXstreamNum(xstreamNum + 1);
        }
    };
    otherNumRef.current = () => {
        if (otherNum >= 16) {
            clearTimeout(timer0);
            clearInterval(timer2);
        } else {
            setOtherNum(otherNum + 1);
        }
    };
    useEffect(() => {
        const clearTimerAll = () => {
            clearInterval(timer2);
            timer2 = null;
            clearInterval(timer1);
            timer1 = null;
            clearTimeout(timer0);
            timer0 = null;
            xstreamNumRef.current = 0;
            xstreamNumRef.current = 0;
            setXstreamNum(0);
            setOtherNum(0);
        };
        if (enter) {
            timer0 = setTimeout(() => {
                timer1 = setInterval(() => {
                    xstreamNumRef.current();
                }, 800 / 80);

                timer2 = setInterval(() => {
                    otherNumRef.current();
                }, 800 / 16);
            }, 1200);
        } else {
            clearTimerAll();
        }
        return () => {
            clearTimerAll();
        };
    }, [enter]);

    // cover
    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
        new ScrollMagic.Scene({
            triggerElement: '.xstream_B',
            triggerHook: 1,
            offset: layoutH * 2 - 150,
            duration: 400,
        })
            .setTween(TweenMax.to('.xstream_B .cover', 0.5, { bottom: 0 }))
            .addTo(controller);
    }, []);

    return (
        <div className={`xstream_B ${css.xstream_B} ${enter ? 'enter_Sec3' : ''}`}>
            <div className="stickyBox">
                <div className="video-wrapper video2" id="canvas-frames1"></div>

                {/* 第二屏 */}
                <div className="section-2">
                    <div className="mask"></div>
                    <div className="text-wrapper">
                        <div className="title">{t('section_2_title')}</div>
                        <div className="desc">{t('section_2_desc')}</div>
                    </div>
                </div>

                {/* 第三屏 */}
                <div className="section-3">
                    <ul className="img-wrapper">
                        <li className="img img-1">
                            <EFFigure name={['03_1.webp', '03_1.jpg']} width="100%" />
                        </li>
                        <li className="img img-2">
                            <EFFigure name={['03_2.webp', '03_2.jpg']} width="100%" />
                        </li>
                        <li className="img img-3">
                            <EFFigure name={['03_3.webp', '03_3.jpg']} width="100%" />
                        </li>
                    </ul>
                    <div className="mask"></div>
                    <div className="text-wrapper">
                        <div className="title">{t('section_3_title')}</div>
                        <div className="desc">{t('section_3_desc')}</div>
                        <div className="content-box">
                            <div className="sub-title">{t('section_3_subtitle')}</div>
                            <div className="process-box">
                                <div className="x-stream">
                                    <div className={`bar`}>
                                        <div className="text">
                                            <span className="num">{xstreamNum}</span>
                                            <span className="unit">%</span>
                                        </div>
                                    </div>
                                    <div className="name">{t('ecoFlow_power_station')}</div>
                                </div>
                                <div className="others">
                                    <div className={`bar`}>
                                        <div className="text">
                                            <span className="num">{otherNum}</span>
                                            <span className="unit">%</span>
                                        </div>
                                    </div>
                                    <div className="name">{t('others')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="cover"></div>
            </div>
        </div>
    );
}
